import Enumerable from "linq";
import {
  DataValidationKinds,
} from "..";
import {
  IItem,
  instanceOfITextValidatable,
  instanceOfITextLengthValidatable,
  ITextValidatable,
  ITextLengthValidatable,
} from "../items";
import { IDocumentAlert } from "../IDocumentAlert";
import { InvalidTextAlert, TextLengthAlert } from "../alerts";
import { AbstractItemValidator } from "./AbstractItemValidator";

export class TextValidator extends AbstractItemValidator {
  protected validateItem(item: IItem, itemSetId: number): IDocumentAlert[] {
    return Enumerable.from([
      instanceOfITextValidatable(item) ? this.validateCharacter(item, itemSetId) : null,
      instanceOfITextLengthValidatable(item) ? this.validateLength(item, itemSetId) : null,
    ])
    .toArray();
  }

  // Officeの実装(呼び元でコメントアウトされているが・・)
  // http://git.pscad.co.jp:8080/gitbucket/documakerGov/WebEditor/blob/8a67bb57a756f2dd92e8948b373821ea0689170f/DocuMakerWebEditor/WebContent/jp/docuMaker/editor/js/ReportEditScreen.js#L718
  public validateCharacter(item: IItem & ITextValidatable, itemSetId: number): IDocumentAlert {
    const text = item.text();
    if (!item.shouldValidateText() || !item.dataValidationKind || !text) {
      return null;
    }
    // TODO:規制対象文字が入力された時点で警告ダイアログが出て入力できないので
    // ここでのチェックは不要？
    const expression = this.toExpression(item.dataValidationKind);
    return (!expression || text.match(expression))
      ? null
      : new InvalidTextAlert(itemSetId, item);
  }

  private toExpression(kind: DataValidationKinds): RegExp {
    switch (kind) {
      case DataValidationKinds.FullWidth:
        return /^[^ -~｡-ﾟ]*$/;
      case DataValidationKinds.FullKana:
        return /^[\u30A0-\u30FF]+$/;
      case DataValidationKinds.HalfKana:
        return /^[\uFF65-\uFF9F]+$/;
      case DataValidationKinds.HalfNumber:
        // v1仕様に合わせて「-」、「.」も検証NGとする
        return /^[0-9]+$/;
      case DataValidationKinds.AlphabetNumber:
        return /^[\x20-\x7E]+$/;
      default:
        console.warn("不明な検証種別です。dataValidationKind: " + kind);
        return null;
    }
  }

  private validateLength(item: IItem & ITextLengthValidatable, itemSetId: number): IDocumentAlert {
    return (!item.enableLengthCheck || !item.lengthChecklength || (item.getTextLength() <= item.lengthChecklength))
      ? null
      : new TextLengthAlert(itemSetId, item);
  }
}
